import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { JudgeType } from "../../../types/ScientificModule";

const initialState: JudgeType = {
    id: "",
    fullname: "",
    idUser: "",
    status: false,
    user: {
        id: undefined,
        name: "",
        userName: "",
        email: "",
        bi: "",
        nuit: "",
        phoneNumber: "",
        dateOfBirth: "",
        gender: "M",
        role: undefined,
        icon: undefined,
        lockoutEnabled: undefined,
        password: undefined,
        roles: undefined,
        claims: undefined
    }
};

const judgesSlice = createSlice({
    name: "judges",
    initialState,
    reducers: {
        setJudgesData: (state, action: PayloadAction<JudgeType>) => ({ ...state, ...action.payload }),
        resetJudgesData: () => ({ ...initialState }),
    },
});

export const { setJudgesData, resetJudgesData } = judgesSlice.actions;

export default judgesSlice.reducer;
